(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockBeratungsverzicht', {
            require: {
                form: '^form'
            },
            bindings: {
                options: '<abbvOptions'
            },
            templateUrl: 'bloecke/beratungsverzicht/blockBeratungsverzicht.html',
            transclude: true,
            controller: BlockBeratungsverzichtController,
            controllerAs: 'beratungsverzichtVm'
        });

    BlockBeratungsverzichtController.$inject = [
        'AngebotModel',
        'BasisAngebotService',
        'AppConfig',
        'FormatUtilsService'
    ];
    function BlockBeratungsverzichtController(AngebotModel, BasisAngebotService, AppConfig, FormatUtilsService) {
        var vm = this;

        vm.$onInit = onInit;

        vm.isAnzeigeTelefonnummerSichtbar = isAnzeigeTelefonnummerSichtbar;
        vm.isAngebotAenderbar = isAngebotAenderbar;

        function activate() {
            vm.angebotModel = AngebotModel.get();
            vm.options = vm.options || {};
            vm.beratungsverzichtText = AppConfig.ANGEBOT.beratungsverzichtText || 'Ich verzichte hiermit im Zusammenhang mit der hier erstellten Tarifauskunft bzw. dem hier erstellten Antrag auf eine Beratung und eine Dokumentation einer konkreten Abschlussempfehlung. Mir ist bewusst, dass sich dieser Verzicht nachteilig auf die Möglichkeit auswirken kann, gegen den Versicherer einen Schadenersatzanspruch wegen einer Verletzung von Beratungspflichten geltend zu machen.';

            var phoneNumber = AppConfig.APP.telefon;

            vm.phoneNumber = {
                display: FormatUtilsService.formatPhoneNumber(phoneNumber, {
                    removeInterantional: true,
                    replaceWhitespaceWithNonBreakingSpace: true
                }),
                call: 'tel:' + FormatUtilsService.formatPhoneNumber(phoneNumber, {
                    internationalCode: '+49'
                })
            };
        }

        function onInit() {
            activate();
        }

        function isAnzeigeTelefonnummerSichtbar() {
            return vm.options.anzeigeTelefonnummer === true;
        }

        function isAngebotAenderbar() {
            return BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANTRAG');
        }
    }

})();
